export const ACCOUNT_SETTINGS_API_AUDIENCE =
    process.env.REACT_APP_OKTA_AUDIENCE;

if (!ACCOUNT_SETTINGS_API_AUDIENCE) {
    throw new Error('Missing REACT_APP_ACCOUNT_SETTINGS_API_AUDIENCE');
}


export const ACR = {
    MFA: 'http://schemas.openid.net/pape/policies/2007/06/multi-factor',
};

export const SENSITIVE_SCOPE = {
    DELETE_ACCOUNT: 'delete:account',
    CHANGE_PASSWORD: 'change:password',
    ENROLL_MFA: 'enroll:mfa',
    UNENROLL_MFA: 'unenroll:mfa',
};

export const CHANGE_TYPE = {
    AUTHENTICATOR: 'totp',
    PHONE: 'phone',
};
